import { render } from "./OverviewCard.vue?vue&type=template&id=68629f32&scoped=true"
import script from "./OverviewCard.vue?vue&type=script&lang=js"
export * from "./OverviewCard.vue?vue&type=script&lang=js"

import "./OverviewCard.vue?vue&type=style&index=0&id=68629f32&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68629f32"]])

export default __exports__